// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_U2m","cls2":"FriendlySutdModal-cls2_jq_ FriendlySutdModal-cls1_U2m"};